//Import required libraries
import React, { useState }  from 'react';
import CancelIcon from '@material-ui/icons/Cancel';
import { v4 as uuidv4 } from 'uuid';

//Import custom components
import ProgressBar from '../components/ProgressBar'
import Input from './Input'

//Import Styles
import './UploadForm.scss';

//Import Data
import formData from '../../../../assets/data/formData.json'
import { store } from '../../../../store/initialState'
import { extractDateMetadataFile } from '../../../../utils/utils';

//Import Utils
// import { extractDate } from '../../../../utils/utils'

//Setting initial form data
let initialUserInput = {}
formData.forEach(obj => {initialUserInput[obj.name] = obj.defaultValue})

let path = store.path
let pathCompressed = store.pathCompressed

const UploadForm = props => {

    let { file, setFile, fileMetaData, setFileMetaData } = props

    if (file) {
        //updating userInput from props
        initialUserInput = {
            ...initialUserInput, 
            ...fileMetaData, 
            pictureId: uuidv4(), 
            path,
            url: URL.createObjectURL(file),
            pathCompressed,
        }
        //Adding date metadata
        initialUserInput = extractDateMetadataFile(initialUserInput)
    } else {
        initialUserInput = {
            ...fileMetaData,
            // DateTimeOriginal: extractDate(fileMetaData.DateTimeOriginal) 
        }
    }

    const [error, setError] = useState(null);
    const [userInput, setUserInput] = useState(initialUserInput)
    const [uploading, setUploading] = useState(false)
    const [deleteFlag, setDeleteFlag] = useState(false);
    // console.log(userInput);

    const handleSave = (e) => {
        // console.log('Uploading...')
        setUploading(true)
    };

    const handleDelete = () => {
        setDeleteFlag(true);
        setUploading(true);
    }

    const handleCancel = () => {
        setFile(false);
        setFileMetaData(null);
    }

    const headerTitle = file ? 'Upload Image' : 'Update Image Metadata'
    const buttonTitle = file ? 'UPLOAD' : 'UPDATE'

    return (
        <>
        <div className='upload-form-overlay'></div>
        <div className='upload-form-container'>
            <div className='upload-form'>
                <div className='upload-form-header'>
                    <span></span>
                    <h1 className='header-title'>{headerTitle}</h1>
                    <CancelIcon className='cancel-icon' onClick={() => {handleCancel()}}/>
                </div>

                <div className="upload-form-body">
                    <div className='picture'>
                        <img src={userInput.url} className='upload-form-picture'></img>
                    </div>
                    <div className='details'>
                        {
                            formData.map((obj, index) => <Input key={index}
                                                            {...obj}
                                                            userInput={userInput}
                                                            setUserInput={setUserInput}
                                                        />)
                        }
                    </div>
                </div>
                <div className="upload-form-footer">
                    {!file && <button onClick={handleDelete} className='danger'>DELETE</button>}
                    <button onClick={handleSave}>{buttonTitle}</button>
                </div>
                <div className="upload-form-progress-bar-container">
                    { uploading && <ProgressBar file={file} 
                                                fileMetaData={userInput}
                                                setFileMetaData={setFileMetaData}
                                                setFile={setFile} 
                                                setUploading={setUploading}
                                                deleteFlag={deleteFlag} /> }
                </div>
            </div>
        </div>
        </>
    )
}

export default UploadForm